// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/styles/base.css'
import './assets/styles/animate.css'
import './assets/styles/borderAnimation.css'
import './assets/styles/video-js.min.css'
import './assets/styles/selfAdaption.css'
import ElementUI from 'element-ui' // elementUi
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/elementUi.css'
// 导入图片预览viewer组件以及css
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import axios from './axios/newAxios.js'
import countTo from 'vue-count-to' // 数字动态变化
import './util/bus.js'
import Moment from 'moment'
Vue.prototype.$axios = axios
Vue.prototype.$moment = Moment
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js